<template>
  <div class="login-weixinbox" v-if="weixinLogin">
    <div class="login">
      <span class="iconfont icon-guanbi1 close" @click="closeCurrentLayer"
        >X</span
      >
      <!--<h1>微信登录<span>SIGN IN</span></h1>-->
      <!-- <wxlogin
                id = "login_container"
                :appid = appid
                scope = "snsapi_login"
                :redirect_uri = "redirect_uri"
                state = ""
                href = ""
                :self_redirect="true"
            >

            </wxlogin> -->
      <iframe
        scrolling="no"
        width="300"
        height="400"
        frameBorder="0"
        allowTransparency="true"
        :src="setSrc"
        sandbox="allow-scripts allow-top-navigation allow-same-origin"
      ></iframe>
      <!--<div id="login_container"></div>-->
    </div>
  </div>
</template>

<script>
// import wxlogin from 'vue-wxlogin';
export default {
    components: {
        // wxlogin
    },
    name: "weixinLogin",
    computed: {
        setSrc() {
            var _url =
                "https://open.weixin.qq.com/connect/qrconnect?appid=" +
                this.appid +
                "&scope=" +
                "snsapi_login" +
                "&redirect_uri=" +
                this.redirect_uri +
                "&state=" +
                "" +
                "&login_type=jssdk&self_redirect=default&style=" +
                "black" +
                "&href=" +
                "";
            return _url;
        },
    },
    mounted() {
        this.$store.commit("saveLicense", sessionStorage.getItem("license"));

        // // 搜狐第三方接口报错，导致returnCitySN获取不到值
        // window.returnCitySN = window.returnCitySN || {
        //   cip: "1.1.1.1",
        //   cid: "111111",
        //   cname: "错误地区",
        // };
        // this.$store.commit("saveIp", window.returnCitySN["cip"]);
        // this.$store.commit("saveAddress", window.returnCitySN["cname"]);
    },
    data() {
        return {
            weixinLogin: true,
            redirect_uri: "",
            appid: process.env.VUE_APP_WEIXIN_APPID,
        };
    },
    created() {
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.src = "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";

        // that.weixinLogin = data;
        if (this.weixinLogin) {
            if (sessionStorage.getItem("weixinLoginHerf") == null) {
                sessionStorage.setItem("weixinLoginHerf", `${window.location.origin}/#/Login`);
            }
            sessionStorage.setItem("QQOrWeiXin", "2");

            // console.log('license', process.env.VUE_APP_LICENSE);
            // console.log(`${process.env.VUE_APP_REDIRECT_URL}/panda/wechat/login/code?reurl=${window.location.href}`);
            // this.redirect_uri = encodeURIComponent(`${process.env.VUE_APP_REDIRECT_URL}/api/compass-auth/signin/wechat/connect/code?current_url=${encodeURIComponent(window.location.href)}`);
            // this.redirect_uri = encodeURIComponent('http://t.lawsdata.com/wangjiyun/wechat/login/code?current_url=http://192.168.0.27:8686/#/login');
            // this.redirect_uri = encodeURIComponent(`http://t.lawsdata.com/qiaoyu/wechat/login/code?reurl=${encodeURIComponent(window.location.href)}&license=${process.env.VUE_APP_LICENSE}`);
            const locationHref = `${window.location.origin}${window.location.pathname}#/Login`; // 拼接当前地址：'http://192.168.0.27:8686/#/Login'
            // this.redirect_uri = encodeURIComponent(
            //     `${process.env.VUE_APP_REDIRECT_URL}/wechat/login/code?reurl=${encodeURIComponent(
            //         locationHref
            //     )}&license=${this.$store.state.license}&ip=${this.$store.state.ip}&address=${this.$store.state.address}`
            // );
            this.redirect_uri = encodeURIComponent(
                `${process.env.VUE_APP_REDIRECT_URL}/wechat/login/code?reurl=${encodeURIComponent(
                    locationHref
                )}&license=${this.$store.state.license}`
            );
        }
    },
    methods: {
        closeCurrentLayer() {
            this.$emit("emitWeixinLogin", false);
        },
    },
};
</script>

<style scoped lang="less" type="text/less">
.login-weixinbox {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    .login {
        position: fixed;
        top: 30%;
        left: 50%;
        margin-left: -242px;
        margin-top: -222.5px;
        width: 484px;
        // margin-left: 50%;
        height: 445px;
        border-radius: 8px;
        background: #fff;
        padding: 43px 60px;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            width: 18px;
            height: 18px;
            cursor: pointer;
            opacity: 0.2;
        }
        h1 {
            font-size: 30px;
            font-weight: bold;
            position: relative;
            margin-bottom: 32px;
            line-height: 36px;
            span {
                width: 100%;
                position: absolute;
                left: 0;
                bottom: -20px;
                opacity: 0.1;
                color: @primary-color;
                font-size: 36px;
                line-height: 36px;
            }
        }
        .login-group {
            height: 54px;
            margin-bottom: 20px;
            position: relative;
            text-align: left;
            i {
                color: #999;
                position: absolute;
                width: 17px;
                display: block;
                left: 18px;
                z-index: 9;
                height: 100%;
                top: -12px;
                font-size: 21px;
            }
            strong {
                position: absolute;
                width: 1px;
                height: 53px;
                left: 54px;
                top: -16px;
                background: #e2e2e2;
                z-index: 9;
            }
            .forget {
                float: right;
                padding: 0;
                text-align: right;
                margin-top: 3px;
            }
            .logbtn {
                width: 100%;
                height: 54px;
                border-radius: 4px;
                font-size: 18px;
            }
            input {
                height: 54px;
                padding-left: 75px;
                border-radius: 0;
                font-size: 16px;
            }
            .otherLogin {
                display: inline-block;
                color: #fff;
                border-radius: 50%;
                width: 34px;
                height: 34px;
                text-align: center;
                line-height: 34px;
                background: #5cc9f5;
                margin-left: 10px;
                cursor: pointer;
                &:nth-child(2) {
                    background: #4fc43b;
                }
            }
        }
    }
}
</style>
